import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import Grid from "../../components/Grid/Grid";
import { CUSTOM_MESSAGES, PAGE_SIZES } from "../../constants/globalConstants";
import { Layout } from "../../layout/PortalLayout/PortalLayout";
import MainHeading from "../../components/MainHeading/MainHeading";
import CustomButton from "../../components/CustomButton/CustomButton";
import ThreeDotActionItem from "../../components/ThreeDotActionItem/ThreeDotActionItem";
import useGridHeight from "../../hooks/useGridHeight";
import { useLazyGetBrandListQuery } from "../../app/api/brandApi";

const BrandPortal = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const navigate = useNavigate();
  useGridHeight();
  const [getBrandListQuery, brandListResponse] = useLazyGetBrandListQuery();

  const pageSizeRef = useRef(String(PAGE_SIZES.Default_List_Size));
  const tableHeaders = [
    {
      headerName: "Name",
      shouldSort: true,
    },
    {
      headerName: "Unique ID",
      shouldSort: true,
    },
    {
      headerName: "Status",
      // shouldSort: true,
    },
    { headerName: "" },
  ];

  const handleGetBrandList = async () => {
    try {
      const response = await getBrandListQuery({
        startKey: "",
        page_size: pageSizeRef.current,
      }).unwrap();

      if (response?.status_code === 200) {
        setTableData(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetBrandList();
    // eslint-disable-next-line
  }, []);

  const updatedTableData = (tableData ?? []).map((tdata) => ({
    Name: tdata.brand_name,
    "Unique ID": tdata.id,
    Status: [
      tdata.is_active
        ? { text: "Active", color: "#12da85" }
        : { text: "Inactive", color: "#bbbbbb" },
    ],
    actionIcon: (
      <ThreeDotActionItem
        actionItemsMenuPositionStyles={{
          right: "15px",
          left: "unset",
        }}
        actionIconSubItemsList={[
          {
            actionItemName: "View Details",
            onClick: (id: string) =>
              navigate(`/provisioning/brand/create?id=${tdata.id}`),
          },
          {
            actionItemName: "Edit Details",
            onClick: (id: string) =>
              navigate(`/provisioning/brand/edit?id=${tdata.id}`),
          },
          // {
          //   actionItemName: "Delete Brand",
          //   onClick: (id: string) => {
          //     setSelectedBrandId(id);
          //     setShowDeleteModal(true);
          //   },
          // },
        ]}
        id={tdata.id}
      />
    ),
  }));

  const handleLoadMoreClick = async () => {
    try {
      if (
        brandListResponse.isSuccess &&
        brandListResponse.data?.next_start_key
      ) {
        const response = await getBrandListQuery(
          {
            startKey: brandListResponse.data?.next_start_key ?? "",
            page_size: pageSizeRef.current,
          },
          true
        );

        if (response && response?.data?.data) {
          setTableData((prev) => [...prev, ...response?.data?.data]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Layout>
        <MainHeading headerText="Brand" subHeaderText={"Description"}>
          <CustomButton
            isSubmitting={false}
            label="Create Brand"
            customClass="w-11rem px-1 py-0 m-0 h-48 fs-6"
            onClick={() => navigate("create")}
            disabled={false}
          />
        </MainHeading>

        <Grid
          tableHeaders={tableHeaders}
          tableData={updatedTableData}
          isLoading={brandListResponse.isLoading}
          isDataPresent={brandListResponse.data?.data?.length > 0}
          isError={brandListResponse.isError}
          error={brandListResponse.error}
          noDataUIMainText={CUSTOM_MESSAGES.No_Brands_Yet}
          noDataUISubText={CUSTOM_MESSAGES.Create_Brand_Now}
          noDataUIButtonLabel="Create Brand"
          showPageSizeSelector
          page_size={pageSizeRef.current}
          handlePageSizeChange={(val) => {
            if (val !== pageSizeRef.current) {
              pageSizeRef.current = val as string;
              handleGetBrandList();
            }
          }}
          sort={{ sortField: "Name", sortOrder: "asc" }}
          handleClick={() => navigate("create")}
        />

        {((brandListResponse.isSuccess &&
          brandListResponse?.data?.next_start_key) ||
          brandListResponse.isFetching) && (
          <div className="text-center" id="loadmore-button">
            <CustomButton
              isSubmitting={brandListResponse.isFetching}
              label="Load More"
              customClass="px-1 mw-100 py-0 m-0 mt-3 fs-6"
              customStyles={{ width: "30rem" }}
              onClick={handleLoadMoreClick}
            />
          </div>
        )}
      </Layout>
    </>
  );
};

export default BrandPortal;
